interface Product {
    id: string;
    productGroup?: string;
    productType: string;
    entitlements: string[];
}

const isPurchased = (entitlementSetId: string): boolean => {
    if (!entitlementSetId) return false;

    // Retrieve the user token
    const hasUserToken = window.dazn?.auth?.unstable_getDecodedJWT();
    const entitlementSets = hasUserToken?.entitlements?.entitlementSets;

    if (!Array.isArray(entitlementSets)) return false;

    // Flatten entitlements array and use a Set for faster lookup
    const entitlementsArray = (
        hasUserToken.entitlements.entitlementSets as unknown as
            | Product[]
            | undefined
    )
        ?.map((item) => item.entitlements || [])
        .reduce((acc, curr) => acc.concat(curr), []);

    const entitlementsSet = new Set(entitlementsArray);

    const isEntitled = entitlementsSet.has(entitlementSetId);

    return isEntitled;
};

export {isPurchased};
